import { ApiResponse } from "@payment-client/interfaces/Api";

// interfaces
import { DashOrderResponse } from "@payment-client/interfaces/OrderPublic";

// constants
import { DEFAULT_RETRY_RESPONSE } from "@payment-client/constants/Order";
import { getOrderDetails } from "@payment-client/apis/publicOrderConfirmationService";
import { GlobalHeaderState, recordNREvent } from "@swiggy-private/checkout-core";
import { OrderApiData } from "@swiggy-private/payment-types";

// Union type that represents the combination of orderDetailsResponse and DEFAULT_RETRY_RESPONSE
export type OrderApiRetryResponse = typeof DEFAULT_RETRY_RESPONSE;

export async function processOrderDetailsResponse(
    apiHost: string,
    params: {
        transactionId: string;
        orderId: string;
        marketplaceBusinessLine?: string;
        marketplaceCategory?: string;
    },
    nrLogTableName: string,
): Promise<{
    retryResponse?: ApiResponse<OrderApiData>;
    orderDetailsResponse: ApiResponse<DashOrderResponse>;
}> {
    const headers = GlobalHeaderState.getHeaders();
    const orderDetailsResponse = await getOrderDetails(apiHost, {
        orderId: params.orderId,
        marketplaceBusinessLine: params.marketplaceBusinessLine,
        marketplaceCategory: params.marketplaceCategory,
    });

    if (orderDetailsResponse.statusCode !== 0) {
        recordNREvent({
            eventType: nrLogTableName,
            statusCode: orderDetailsResponse.statusCode,
            orderId: params.orderId,
            ...headers,
        });

        // Create retry response matching server-side DEFAULT_RETRY_RESPONSE
        const response = {
            ...orderDetailsResponse,
            ...DEFAULT_RETRY_RESPONSE,
        } as ApiResponse<OrderApiData>;

        return { retryResponse: response, orderDetailsResponse };
    }

    return { orderDetailsResponse };
}
